import {observer} from "mobx-react";
import Card from "../../../../../components/layouts/card/card";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import ListLayout from "../../../../../components/layouts/list-layout/list-layout";
import {Fragment} from "react";
import GridLineLayout from "../../../../../components/layouts/grid-line-layout/grid-line-layout";
import GridLine from "../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import GridLineIndicators
    from "../../../../../components/layouts/grid-line-layout/grid-line/grid-line-indicators/grid-line-indicators";
import GridLineButtons
    from "../../../../../components/layouts/grid-line-layout/grid-line/grid-line-buttons/grid-line-buttons";
import {ButtonIcon} from "../../../../../components/inputs/button-icon/button-icon";
import IconEdit from "../../../../../components/icons/icon-edit/icon-edit";
import {useNavigate} from "react-router-dom";
import {ExpandCallapseStore} from "../../../../../hooks/expand-collapse-hook";
import dashboardSettingsStore from "../../../../../stores/dashboard-settings-store";
import { PROFILE_CAPABILITIES } from "../../../../../models/ProfileCapabilities";

interface Props {
    expandCollapseStore: ExpandCallapseStore;
}

const SettingsCard: React.FC<Props> = observer(({ expandCollapseStore }) => {
    const addressSlipCapability = dashboardSettingsStore.resolveCapability(
        PROFILE_CAPABILITIES.RETURN_METHOD_ADDRESS_SLIP_SETTINGS
    );
    const packingSlipSettings = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.RETURN_METHOD_PACKING_SLIP_SETTINGS);
    
    const isAddressSlipSupported = addressSlipCapability?.isSupported;
    const isPackingSlipSupported = packingSlipSettings?.isSupported;

    // Hide the entire Settings card if both capabilities are not supported
    if (!isAddressSlipSupported && !isPackingSlipSupported) {
        return null;
    }

    const cards = [
        {
            title: 'Settings',
            instructions: '',
            isAllowed: true,
            isExpanded: false,
            lineGroups: [{
                title: '',
                lines: [
                    {
                        title: 'Address slip',
                        pathname: 'locale-address-slip-fields-translate',
                        isAllowed: isAddressSlipSupported
                    },
                    {
                        title: 'Packing slip',
                        pathname: 'locale-packing-slip-fields-translate',
                        isAllowed: isPackingSlipSupported
                    },
                ],
            }]
        },
    ];

    const navigate = useNavigate();
    const onOptionClicked = (pathname: string) => {
        navigate({
            pathname: pathname
        });
    };
    return (
        <ListLayout>
            {
                cards.map((card, index) => (
                    <Card
                        toolbar={{
                            title: <FontBody1 color={FONT_COLOR.PRIMARY2}
                                              variant={FONT_VARIANT.BOLD}>{card.title}</FontBody1>,
                        }}
                        key={index}
                        isExpanded={expandCollapseStore.getIsExpanded(card.title)}
                        expandCallback={(v: boolean) => expandCollapseStore.setExpanded(card.title, v)}
                    >
                        <FontBody1 color={FONT_COLOR.PRIMARY3_50}>{card.instructions}</FontBody1>
                        {card.lineGroups.map((lineGroup, groupIndex) => (
                            <Fragment key={groupIndex}>
                                {!!lineGroup.title.length &&
                                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                        {lineGroup.title}
                                    </FontBody1>}

                                <GridLineLayout>
                                    {lineGroup.lines.filter(line => line.isAllowed).map((line, lineIndex) => (
                                        <GridLine
                                            key={lineIndex}
                                            onClick={() => onOptionClicked(line.pathname)}
                                            settings={{
                                                columns: [{width: 2}, {width: 30, type: 'px'}, {width: 60, type: 'px'}]
                                            }}
                                            columns={[
                                                <GridLineItem>
                                                    <FontBody1
                                                        color={FONT_COLOR.PRIMARY2}
                                                        variant={[FONT_VARIANT.BOLD]}
                                                    >
                                                        {line.title}
                                                    </FontBody1>
                                                </GridLineItem>,

                                                <GridLineIndicators>
                                                </GridLineIndicators>,

                                                <GridLineButtons>
                                                    <ButtonIcon
                                                        Component={IconEdit}
                                                        onClick={() => onOptionClicked(line.pathname)}
                                                    />
                                                </GridLineButtons>,
                                            ]}/>
                                    ))}
                                </GridLineLayout>
                            </Fragment>
                        ))}
                    </Card>
                ))
            }
        </ListLayout>
    )
});

export default SettingsCard;